"use client";

import clsx from "clsx";
import type { ComponentProps } from "react";

import { Body } from "@shared/ui/typography";

import type { VacancyListType } from "../../model";
import { VacancyListItem } from "../vacancy-list-item";

import s from "./vacancy-table.module.scss";

export type VacancyTableProps = ComponentProps<"div"> & {
  className?: string;
  vacancyList: VacancyListType;
};

export const VacancyTable = (props: VacancyTableProps) => {
  const { className, vacancyList } = props;

  if (vacancyList.length === 0) {
    return null;
  }

  return (
    <section className={clsx(s.root, className)}>
      <Body tag="div" size="primary" weight="semiBold" className={s.header}>
        <div className={s.cell}>Должность</div>
        <div className={s.cell}>Зарплата</div>
        <div className={s.cell}>Опыт</div>
        <div className={s.cell}>Занятость</div>
        <div className={s.cellMobile}>Должность</div>
      </Body>
      {vacancyList.map((vacancy) => (
        <VacancyListItem
          key={vacancy.id}
          vacancy={vacancy}
          className={s.row}
          cellClassName={s.cell}
        />
      ))}
    </section>
  );
};

VacancyTable.displayName = "VacancyTable";
